'use strict'

export default typeof Blob !== 'undefined' ? Blob : null



//////////////////
// WEBPACK FOOTER
// ./~/_axios@1.4.0@axios/lib/platform/browser/classes/Blob.js
// module id = 144
// module chunks = 1